import React, {useState} from 'react';

export default ({user, onChange}) => {
    const [gender, setGender] = useState(user.gender);
    return (
		<div className="margin-top-1 margin-bottom-1">
            <label>Gender</label>
            <div className="row margin-top-1" style={{flexFlow: 'nowrap'}}>
                <button 
                    data-ta="user.gender.male"
                    className={( gender === 'MALE' ? "button neo preselect " : "button neo") 
                    + "button neo form mdl-wide margin-right-1"}
                    onClick={() => {onChange('MALE'); setGender('MALE');}} style={{minWidth: '8vw'}}>
                    Male
                    </button>
                <button 
                    data-ta="user.gender.female"
                    className={( gender === 'FEMALE' ? "button neo preselect " : "button neo") 
                    + "button neo form mdl-wide margin-right-1"}
                    onClick={() => {onChange('FEMALE'); setGender('FEMALE');}} style={{minWidth: '8vw'}}>
                    Female
                    </button>
                
            </div>
            <div className="row">
                <button 
                    data-ta="user.gender.non-binary"
                    className={( gender === 'NON-BINARY' ? "button neo preselect " : "button neo") 
                    + "button neo form mdl-wide margin-right-1"}
                    onClick={() => {onChange('NON-BINARY'); setGender('NON-BINARY')}} style={{minWidth: '8vw'}}>
                    Non-Binary
                </button>
                <button 
                    data-ta="user.gender.na"
                    className={( gender === 'PREFER NOT TO SAY' ? "button neo preselect " : "button neo") 
                    + "button neo form mdl-wide margin-right-1"}
                    style={{minWidth: '8vw'}}
                    onClick={() => {onChange('PREFER NOT TO SAY'); setGender('PREFER NOT TO SAY')}}>
                    Prefer Not To Say
                </button>
            </div>
        </div>
	)
}